var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-wrap"},[_vm._l((_vm.menus),function(m){return [_c('div',{key:m.name,staticClass:"flex-col flex-center menu-item",class:{'menu-item-actived':_vm.isRouteActive('/core/self/'+m.path)},on:{"click":function($event){return _vm.RouteTo(m.path)}}},[_vm._v(" "+_vm._s(m.name)+" "),_c('div',{staticClass:"slash"})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }